const COMMON_PREFIX = 'SAGAR_PANDAV_RESUME_';
const KEYS = {
    ID_KEY: `${COMMON_PREFIX}ID_KEY`,
    VIEW_COUNT_KEY: `${COMMON_PREFIX}VIEW_COUNT`
}

const createUniqueId = () => {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    window.localStorage.setItem(KEYS.ID_KEY, `${array[0]}`);
    createViewCount();
};

const getUniqueId = () => {
    return window.localStorage.getItem(KEYS.ID_KEY);
};

const createViewCount = () => {
    return window.localStorage.setItem(KEYS.VIEW_COUNT_KEY, '0');
};

const getViewCount = () => {
    return window.localStorage.getItem(KEYS.VIEW_COUNT_KEY);
};

const incrementViewCount = () => {
    const newViewCount = Number(window.localStorage.getItem(KEYS.VIEW_COUNT_KEY)) + 1;
    window.localStorage.setItem(KEYS.VIEW_COUNT_KEY, `${newViewCount}`);
};

export const registerView = () => {
    if (getUniqueId() === null) {
        createUniqueId();
    }
    if (getViewCount() === null) {
        createViewCount();
    }
    incrementViewCount();
    return {
        ID: getUniqueId(),
        VIEW_COUNT_KEY: getViewCount(),
        CLIENT_DATE: new Date().toString()
    }
};